import API from "api/client";
import { envConfig } from "config";

const { userGroupsAPI } = envConfig;

/**
 * @param req {object}
 * @param req.label {string}
 * @param req.members {Array}
 * @returns {Promise<{}>}
 */
const createUserGroup = (req) => {
  return API.post(`${userGroupsAPI}`, req).then((res) => res.data);
};

/**
 * @param id {string|int}
 * @returns {Promise<{}>}
 */
const deleteUserGroup = (id) => {
  return API.delete(`${userGroupsAPI}${id}`).then((res) => res.data);
};

/**
 * @param groupId {string|int}
 * @returns {Promise<{}>}
 */
const getUserGroupMemberships = (groupId) => {
  return API.get(`${userGroupsAPI}${groupId}/memberships`).then((res) => res.data);
};

/**
 * @param id {string|int}
 * @param req {object}
 * @param req.label {string}
 * @param req.members {Array}
 * @returns {Promise<{}>}
 */
const updateUserGroup = (id, req) => {
  return API.put(`${userGroupsAPI}${id}`, req).then((res) => res.data);
};

export default {
  create: createUserGroup,
  delete: deleteUserGroup,
  listMemberships: getUserGroupMemberships,
  update: updateUserGroup,
};
